export const SIDE_BAR_TABS = ["SIMULATION", "ALLOCATION"];
